/* ------------------------------------------------------------------
 * 検索フォーム：商品名検索（title:構文）への整形  2026-10
 * 利用者はこれまでどおり「経本」「習礼」と入力する。送信時に q を
 * 「title:経本」のように整形して Shopify の検索側で商品名に絞り込む。
 * 複数語は空白区切りで各語に title: を付ける（AND検索）。
 * 既に検索構文（title: sku: 等の「:」、引用符、AND/OR/NOT、-除外）を
 * 含む入力は二重付与せずそのまま送る。
 * 対象：action が routes.search_url のフォームで、type が未指定または product のもの。
 * （記事検索など type=article のフォームは変更しない）
 * ------------------------------------------------------------------ */
(function () {
  function toTitleQuery(raw) {
    var q = String(raw || '').replace(/　/g, ' ').trim();
    if (q === '') return q;
    if (/[:"]/.test(q)) return q;
    if (/(^|\s)(AND|OR|NOT)(\s|$)/.test(q)) return q;
    if (/(^|\s)-\S/.test(q)) return q;
    q = q.replace(/\*/g, '').trim();
    if (q === '') return q;
    return q.split(/\s+/).map(function (w) { return 'title:' + w; }).join(' ');
  }

  function normalizePath(p) {
    return String(p || '').split('?')[0].replace(/\/+$/, '');
  }

  function isSearchForm(form) {
    var searchUrl = (window.routes && window.routes.searchUrl) || '/search';
    var action = form.getAttribute('action');
    if (!action) return false;
    var a = normalizePath(action);
    var s = normalizePath(searchUrl);
    return a === s || a === '/search' || /\/search$/.test(a);
  }

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || form.tagName !== 'FORM' || !isSearchForm(form)) return;

    var typeInput = form.querySelector('input[name="type"], select[name="type"]');
    if (typeInput && typeInput.value && typeInput.value !== 'product') return;

    var qInput = form.querySelector('input[name="q"]');
    if (!qInput) return;

    qInput.value = toTitleQuery(qInput.value);

    if (!typeInput) {
      var hidden = document.createElement('input');
      hidden.type = 'hidden';
      hidden.name = 'type';
      hidden.value = 'product';
      form.appendChild(hidden);
    }

    var pageInput = form.querySelector('[name="page"]');
    if (pageInput) pageInput.parentNode.removeChild(pageInput);
  }, true);

  window.naoshichiSearch = { toTitleQuery: toTitleQuery };
})();
